// extracted by mini-css-extract-plugin
export default {"btnsPanel":"pinCode_btnsPanel__RAEhi"};